import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    status: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
    },
  };
};
